// DS2 Badge: a small state label in one of five colours, optionally with a dot before the text.
import cx from "classnames";
import type { HTMLAttributes } from "react";
import styles from "./Badge.module.css";

export type BadgeColor = "success" | "info" | "warning" | "error" | "grey";

export type BadgeProps = Omit<HTMLAttributes<HTMLSpanElement>, "color"> & {
  color: BadgeColor;
  dot?: boolean;
};

export function Badge({ color, dot, className, ...props }: BadgeProps) {
  return <span className={cx(styles.badge, styles[color], dot && styles.dot, className)} {...props} />;
}
